var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 129,
    height: 129,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "rgba(255, 255, 255, 0)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-1.1428571428571428s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(10.285714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-1.1092436974789917s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(20.571428571428573 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-1.0756302521008403s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30.857142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-1.0420168067226891s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(41.142857142857146 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-1.0084033613445378s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(51.42857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.9747899159663865s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(61.714285714285715 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.9411764705882353s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.907563025210084s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82.28571428571429 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.8739495798319328s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(92.57142857142857 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.8403361344537815s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(102.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.8067226890756303s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(113.14285714285714 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.773109243697479s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(123.42857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.7394957983193278s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(133.71428571428572 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.7058823529411765s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.6722689075630253s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(154.28571428571428 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.6386554621848739s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(164.57142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.6050420168067226s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(174.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.5714285714285714s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(185.14285714285714 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.5378151260504201s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(195.42857142857142 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.5042016806722689s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(205.71428571428572 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.47058823529411764s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(216 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.4369747899159664s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(226.28571428571428 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.40336134453781514s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(236.57142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.3697478991596639s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(246.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.33613445378151263s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(257.14285714285717 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.3025210084033613s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(267.42857142857144 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.2689075630252101s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(277.7142857142857 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.23529411764705882s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(288 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.20168067226890757s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(298.2857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.16806722689075632s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(308.57142857142856 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.13445378151260504s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(318.85714285714283 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.10084033613445378s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(329.14285714285717 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.06722689075630252s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(339.42857142857144 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.03361344537815126s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(349.7142857142857 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0500ff",
    height: 14,
    width: 3,
    ry: 0,
    rx: 0,
    y: 16,
    x: 48.5
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    dur: "1.1764705882352942s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/Spinner.e8c828252819912938db94be360a0d6e.svg";
export { ForwardRef as ReactComponent };